var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.boxStyle)},_vm._l((_vm.reminders),function(reminder){return _c('a-tag',{key:'reminder-' + reminder.id,attrs:{"color":_vm.markName === reminder.name ? 'orange': ''}},[_vm._v(_vm._s(reminder.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }